import {
    apiRequest,
    PengaturanAccessDetail,
    PengatuanAccessMenuList
} from "../../../../../services/adapters/kepegawaian/accessService"

class DetailRepository {

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest('get', PengaturanAccessDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchMenu = async (query, cancelToken) => {
        return await apiRequest('get', PengatuanAccessMenuList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DetailRepository 